import { render } from "./ServicesCart.vue?vue&type=template&id=703fef4e&scoped=true"
import script from "./ServicesCart.vue?vue&type=script&lang=js"
export * from "./ServicesCart.vue?vue&type=script&lang=js"

import "./ServicesCart.vue?vue&type=style&index=0&id=703fef4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703fef4e"]])

export default __exports__